import React from "react";
import { Navbar }   from "../components/navbar/Navbar";
import { Footer }   from "../components/footer/Footer";
import { HeroImg2 }   from "../components/heroImages/HeroImg2";
import { AboutContent } from "../components/about/AboutContent";
import config from "../components/contact/config";

export const About = () => {
  const myCurrentRole = config.myCurrentRole;  
  return (
    <div>
      <Navbar />
      <HeroImg2 heading="ABOUT" text={`I'm a friendly  ${myCurrentRole}`}
       />
      <AboutContent/>
      <Footer />
    </div>
  );
};
